<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class="data-grid" style="">
      <dx-data-grid ref='refLineStatus'
        :data-source='machineFaultInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :auto-navigate-to-focused-row="false"
        :focused-row-key.sync='focusedRowKey'
        key-expr="seqId"
        @toolbar-preparing='onToolbarPreparing'
        @cell-prepared='onCellPrepared'
        @row-updated='onRowUpdated' @row-updating="onRowUpdating"
        @row-removed='onRowRemoved'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          :file-name="exportTitle"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxEditing
          :allow-deleting="true"
          :allow-updating="true"
          :allow-adding="false"
          :use-icons="true"
          mode='popup'
        >
          <DxPopup
            :show-title="true"
            :width="700"
            :height="320"
            title="수리결과 등록"
          >
            <dx-position
              my="center"
              at="center"
              of="window"
            />
          </DxPopup>
          <DxForm>
            <DxItem
              :col-count="2"
              :col-span="2"
              item-type="group"
            >
              <DxItem data-field="접수일자"/>
              <DxItem data-field="라인명"/>
              <DxItem data-field="설비명"/>
              <DxItem data-field="고장시간"/>
              <DxItem data-field="수리완료시간"/>
              <DxItem data-field="계통코드"/>
              <DxItem data-field="고장유형코드"/>
              <DxItem data-field="고장내역"/>
            </DxItem>
            <DxItem
              :col-count="1"
              :col-span="2"
              item-type="group"
            >
              <DxItem data-field="수리내역"/>
            </DxItem>
          </DxForm>
        </DxEditing>
        <DxColumnFixing :enabled="true"/>
        <DxColumn
          :allowEditing='false'
          :fixed="true"
          caption="고장접수일"
          data-field="접수일자"
          dataType='datetime'
          sort-order='desc'
          format='yyyy-MM-dd HH:mm'>
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :fixed="true"
          caption="라인명"
          data-field="라인명"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :fixed="true"
          caption="설비명"
          data-field="설비명"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :fixed="true"
          caption="설비코드"
          data-field="설비코드"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="고장발생시간"
          data-field="고장시간"
          dataType='datetime'
          format='yyyy-MM-dd HH:mm'>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="수리완료시간"
          data-field="수리완료시간"
          dataType='datetime'
          format='yyyy-MM-dd HH:mm'>
          <dx-required-rule message="항목을 선택하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="수리시간"
          :calculate-cell-value="calculateRepairTime">
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="고장계통"
          data-field="계통코드"
          :visible='true'
        >
          <dx-required-rule message="항목을 선택하세요"/>
          <DxLookup
            :data-source="faultDefineLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="고장유형"
          data-field="고장유형코드"
          :visible='true'
        >
          <dx-required-rule message="항목을 선택하세요"/>
          <DxLookup
            :data-source="faultTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="고장내역"
          data-field="고장내역"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="수리내역"
          data-field="수리내역"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="신고자"
          data-field="createid"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          width="100"
          :buttons="editButtons"
          type="buttons"
        />
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            column="접수일자"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxPopup, DxEditing, DxScrolling, DxFilterRow, DxColumnFixing, DxTotalItem, DxLookup,
  DxPosition, DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel, DxExport, DxForm } from 'devextreme-vue/data-grid'
import { DxItem } from 'devextreme-vue/form'
import { DxRequiredRule } from 'devextreme-vue/validator'
import axios from 'axios'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '설비수리현황'
        }
      ],
      machineFaultInfoList: null,
      exportTitle: '설비수리현황',
      faultDefineLookup: null,
      faultTypeLookup: null,
      focusedRowKey: null,
      thisYear: null,
      yearArray: [],
      editButtons: null
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxPopup,
    DxEditing,
    DxScrolling,
    DxFilterRow,
    DxColumnFixing,
    DxTotalItem,
    DxLookup,
    DxPosition,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxExport,
    DxForm,
    DxItem,
    DxRequiredRule
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    if (this.userInfo.permission === this.$_.findWhere(ConstDef.USER_PERMISSION, { groupName: '시스템관리자' }).permission) {
      this.editButtons = ['edit', 'delete']
    } else {
      this.editButtons = ['edit']
    }
    this.thisYear = AppLib.getThisYear()
    for (let i = this.thisYear; i >= 2020; i--) {
      this.yearArray.push({ 'year': i })
    }
    this.faultDefineLookup = this.$store.getters.getBaseDataByType(ConstDef.고장계통)
    this.faultTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.고장유형)
    this.refreshFaultList()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {
  },
  methods: {
    calculateRepairTime (row) {
      if (row.수리완료시간 === null) {
        return null
      }
      let diff = (row.수리완료시간 - row.고장시간) / 1000 / 60
      if (diff < 60) {
        return `${diff}분`
      } else if (diff < (24 * 60)) {
        return `${(diff / 60).toFixed(1)}시간`
      } else {
        const day = Math.floor(diff / 60 / 24)
        let hr = diff - (day * 60 * 24)
        hr = Math.ceil(hr / 60)
        return `${day}일 ${hr}시간`
      }
    },
    onCellPrepared  (e) {

    },
    onRowRemoved (row) {
      this.$_sp.runDeleteSqlProc('설비고장', [{ seqId: row.data.seqId }])
        .then((date) => {
        })
    },
    onRowUpdated (row) {
      console.log(row.data)
      row.data.updateid = this.userInfo.userName
      row.data.updatetime = AppLib.getNow()
      if (row.data.수리완료시간 !== null && (typeof row.data.수리완료시간) === 'object') {
        row.data.수리완료시간 = row.data.수리완료시간.getTime()
      }
      this.$_sp.runUpdateSqlProc('설비고장', ['seqId'], ['createid', 'createtime', '라인명', '설비명'], [row.data])
        .then((date) => {
        })
    },
    onRowUpdating (row) {
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>연도 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.yearArray,
            valueExpr: 'year',
            displayExpr: 'year',
            value: this.thisYear,
            onValueChanged: (args) => {
              this.thisYear = args.value
              this.refreshFaultList()
            }
          }
        }
      )
    },
    refreshFaultList () {
      const status = this.$_sp.runNoEncodeFindProc('spFindAllMachineRepairByYear', { year: this.thisYear })
      axios.all([status])
        .then(axios.spread((...reponse) => {
          this.machineFaultInfoList = this.$_sp.MakeModel(reponse[0])
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">
</style>
